import * as Yup from 'yup';
import filesHelper from 'helpers/files';

export const zipCodeValidation = (props) => {
	return Yup.string()
		.typeError(props.t('common:zipcodeInvalid'))
		.test('invalidZipcode', props.t('common:zipcodeInvalid'), (zipcode) => zipcode && zipcode.length === 5)
		.matches(/^\d+$/, props.t('common:zipcodeInvalid'));
};

export const cityValidation = (props) => {
	return Yup.string()
		.typeError(props.t('common:cityInvalid'))
		.required(props.t('common:cityRequired'))
		.matches(/^[a-zA-Z\s.\-']+$/, props.t('common:cityInvalid'));
};

const FILE_SIZE_10_MB = 1024 * 1024 * 10;

export const licenseFile = (t) => {
	return Yup.mixed().test('fileSize', t('signup:steps.step3.fileIsTooLarge'), (value) =>
		value ? filesHelper.validateSize(value, FILE_SIZE_10_MB) : true,
	);
};

export const requiredLicenseFile = (fileLastFieldName, t, requiredText) => {
	return Yup.mixed().when(fileLastFieldName, (fileLast, schema, node) => {
		const newSchema = schema
			.required(requiredText)
			.test('fileSize', t('signup:steps.step3.fileIsTooLarge'), (value) =>
				value ? filesHelper.validateSize(value, FILE_SIZE_10_MB) : true,
			);

		return !fileLast || (fileLast && node.value) ? newSchema : schema;
	});
};
